export { default } from "./TableSortLabel.js";
export { default as tableSortLabelClasses } from "./tableSortLabelClasses.js";
export * from "./tableSortLabelClasses.js";